<template>
  <button
    :type="button.type"
    class="btn"
    v-bind="$attrs"
    :disabled="isBusy"
    v-on="$listeners"
  >
    <half-circle-spinner
      v-if="isBusy"
      class="mx-6"
      :animation-duration="1000"
      :size="24"
      :color="spinnerColor"
    />
    <slot v-else />
  </button>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';

export default {

  components: {
    HalfCircleSpinner,
  },

  props: {
    button: {
      type: Object,
      default() {
        return {
          type: 'button',
        };
      },
    },

    isBusy: {
      type: Boolean,
      required: false,
      default: false,
    },

    spinnerColor: {
      type: String,
      required: false,
      default: '#ffffff',
    },

  },
};
</script>

<style lang="scss" scoped>
.btn {
  @apply items-center;
  @apply justify-center;
  @apply font-semibold;
  @apply py-2;
  @apply px-4;
  @apply rounded;
  @apply shadow-md;
  @apply outline-none;

  &-naked {
    @apply shadow-none;
    @apply rounded-none;
  }

  &-primary {
    @apply bg-pink-500;
    @apply text-white;

    &:hover {
      @apply bg-pink-800;
    }
  }

  &-secondary {
    @apply bg-white;
    @apply text-gray-900;

    &:hover {
      @apply bg-gray-300;
    }
  }

  &-flat {
    @apply shadow-none;
    @apply uppercase;
    @apply tracking-wider;

    &:hover {
      @apply bg-pink-100;
      @apply text-pink-700;
    }

    &-secondary {
      @apply shadow-none;
      @apply uppercase;
      @apply tracking-wider;
      @apply text-gray-700;
      @apply bg-gray-100;

      &:hover {
        @apply bg-gray-200;
      }
    }

    &-emphasized {
      @apply bg-pink-100;
      @apply text-pink-700;

      &:hover {
        @apply bg-pink-700;
        @apply text-white;
      }
    }
  }

  &-input {
    @apply py-2;
    @apply border-2;
    @apply border-gray-200;
    @apply -ml-1;
    @apply rounded-r #{!important};

    @media(min-width: theme('screens.sm')) {
      @apply py-1;
    }
  }

  &:disabled {
      @apply opacity-50 cursor-not-allowed;
  }
}
</style>
